import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './card';
import { Badge } from './badge';
import { Award, User, Calendar, CheckCircle, FileText } from 'lucide-react';

interface ScoringResultsDisplayProps {
  submissionScore: any;
  showDetailedScores?: boolean; // New prop to control whether to show detailed scores or just comments
}

const ScoringResultsDisplay: React.FC<ScoringResultsDisplayProps> = ({ submissionScore, showDetailedScores = true }) => {
  console.log('ScoringResultsDisplay rendered with:', { submissionScore, showDetailedScores });
  
  if (!submissionScore) {
    return (
      <Card>
        <CardContent className="p-6">
          <p className="text-gray-500 text-center">No scoring data available</p>
        </CardContent>
      </Card>
    );
  }

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleString();
  };

  const getScoreColor = (score: number, maxScore: number) => {
    const percentage = (score / maxScore) * 100;
    if (percentage >= 80) return 'text-green-600';
    if (percentage >= 60) return 'text-yellow-600';
    return 'text-red-600';
  };

  const getScoreBadgeVariant = (score: number, maxScore: number) => {
    const percentage = (score / maxScore) * 100;
    if (percentage >= 80) return 'default';
    if (percentage >= 60) return 'secondary';
    return 'destructive';
  };

  return (
    <div className="space-y-6">
      {/* Legacy Score */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Award className="h-5 w-5 text-yellow-600" />
            Score
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center gap-2">
            <span className={`text-2xl font-bold ${getScoreColor(submissionScore.legacyScore?.score || 0, 170)}`}>
              {submissionScore.legacyScore?.score || 0}
            </span>
            <span className="text-gray-600">/ 170</span>
            <Badge variant={getScoreBadgeVariant(submissionScore.legacyScore?.score || 0, 170)}>
              {Math.round(((submissionScore.legacyScore?.score || 0) / 170) * 100)}%
            </Badge>
          </div>
        </CardContent>
      </Card>

      {/* Legacy Feedback */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <FileText className="h-5 w-5 text-green-600" />
            Feedback
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            {submissionScore.legacyScore?.feedback ? (
              <div className="p-4 bg-blue-50 border border-blue-200 rounded-md">
                <p className="text-gray-700 whitespace-pre-wrap">{submissionScore.legacyScore.feedback}</p>
              </div>
            ) : (
              <div className="text-center py-8">
                <p className="text-gray-500">No feedback available yet.</p>
              </div>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ScoringResultsDisplay;

